/**
 * Creates a query object from form values, including only non-empty string values
 * from the specified fields.
 *
 * @param values The form values object
 * @param fields Array of field names to include in the query
 * @returns An object with non-empty values for the specified fields
 */
const queryObjectFromValues = (
  values: Record<string, any>,
  fields: string[]
): Record<string, any> => {
  const queryObject: Record<string, any> = {}

  fields.forEach(field => {
    if (values[field] && values[field] !== '') {
      queryObject[field] = values[field]
    }
  })

  return queryObject
}

export default queryObjectFromValues
